<template>
  <v-expansion-panel id="exp-panel">
    <v-expansion-panel-content
      id="exp-panel-content"
      v-for="(item, i) in 1"
      :key="i"
    >
      <template v-slot:header>
        <div style="height: 20px;  margin-top:-5px; margin-bottom:15px;">
          Comentarios
          <v-chip class="ma-2" color="teal" text-color="white">{{
            totalComments
          }}</v-chip>
        </div>
      </template>
      <v-card>
        <v-card-text
          ><div v-for="item in listComments" :key="item.id" class="text-xs">
            <v-chip class="light-green">{{ item.usernameAuthor }} </v-chip>
            <v-chip>
              {{ item.createdAt }} - - <b> {{ item.comment }}</b>
            </v-chip>
          </div>
        </v-card-text>
        <div v-if="canAddComments" class="d-flex flex-row align-center mx-4">
          <v-text-field
            v-model="msg"
            placeholder="Escribe un Comentario"
            @keypress.enter="send"
          ></v-text-field>
          <v-btn icon class="ml-1" @click="send"
            ><v-icon>mdi-send</v-icon></v-btn
          >
        </div>
      </v-card>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
export default {
  props: {
    field: Object,
    canAddComments: Boolean
  },
  data () {
    return {
      listComments: null,
      totalComments: 0,
      msg: ''
    }
  },
  methods: {
    fetchCommentsByIdField () {
      this.loading = true
      this.axios
        .get(`informe-auditoria-field/comments`, {
          params: {
            field: this.field.id
          }
        })
        .then(response => {
          this.listComments = response.data
          this.totalComments = response.data.length
          this.loading = false
        })
        .catch(error => {
          this.$store.commit('setErrorMsg', error)
        })
    },
    send (event) {
      this.loading = true
      let payload = {
        report_response_field: this.field.id,
        author: this.$store.state.authUser,
        comment: this.msg
      }
      this.axios
        .post(`informe-auditoria-field/comments/create`, payload)
        .then(response => {
          this.listComments.push(response.data)
          this.loading = false
          this.msg = ''
          this.totalComments++
        })
        .catch(error => {
          this.$store.commit('setErrorMsg', error)
        })
    }
  },
  computed: {},
  components: {},
  created () {
    this.fetchCommentsByIdField()
  }
}
</script>
<style>
#exp-panel {
  color: rgba(0, 0, 0, 0.87);
  max-width: 100%;
  margin-bottom: 20px;
  margin-top: 20px;
  border: 1px solid #c6c6c6;
}
#exp-panel-content {
  background-color: #d9ddcd !important;
}
</style>
